"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.reflect.get");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _mobx = require("mobx");

var _mobxReactForm = require("mobx-react-form");

var _Field = _interopRequireDefault(require("./Field"));

var _isRequired = _interopRequireDefault(require("../validators/isRequired"));

var _ConfigParser = _interopRequireDefault(require("../utils/ConfigParser"));

var _FormUtils = _interopRequireDefault(require("../utils/FormUtils"));

var _class, _descriptor, _descriptor2, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var Form = (_class = (_temp = /*#__PURE__*/function (_MobxReactForm) {
  _inherits(Form, _MobxReactForm);

  var _super = _createSuper(Form);

  function Form(props, options, formConfig) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this, props, options);

    _initializerDefineProperty(_assertThisInitialized(_this), "manuallyChanged", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "hasSubmitted", _descriptor2, _assertThisInitialized(_this));

    _this.name = formConfig.id; // Keep the form config around

    _this.formConfig = formConfig;
    return _this;
  }

  _createClass(Form, [{
    key: "submit",
    value: function submit() {
      var _this2 = this;

      var hooks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var oldOnSuccess = hooks.onSuccess,
          onError = hooks.onError;

      var onSuccess = function onSuccess() {
        // fix false positives on validation errors
        // when field value is object and not recognising validations
        // on the field only the nested fields
        var fieldErrors = _FormUtils.default.mapFormErrors(_this2);

        if (fieldErrors.length > 0) {
          // manually set form as having errors
          _this2.invalidate('Form has errors');

          if (onError) {
            onError();
          }
        } else if (oldOnSuccess) {
          oldOnSuccess.apply(void 0, arguments);
        }
      };

      return _get(_getPrototypeOf(Form.prototype), "submit", this).call(this, {
        onSuccess: onSuccess,
        onError: onError
      });
    }
    /**
     * manuallyChanged relates to a manual field state update i.e in tiled checkbox
     * hasSubmitted relates to onSubmit when you only want to show the form on Submit.
     */
    //this value comes from a manual field state update

  }, {
    key: "setManuallyChanged",
    value: function setManuallyChanged(changed) {
      this.manuallyChanged = changed;
    }
  }, {
    key: "setFormSubmitted",
    value: function setFormSubmitted(hasSubmitted) {
      this.hasSubmitted = hasSubmitted;
    }
  }, {
    key: "makeField",
    value: function makeField(props) {
      // Pass a reference to the form store (this) to the field as it needs to access other fields.
      return new _Field.default(props, this);
    }
  }, {
    key: "getFieldFromSection",
    value: function getFieldFromSection(fieldId, sectionId) {
      return this.$("".concat(sectionId, "__").concat(fieldId));
    }
  }, {
    key: "bindings",
    value: function bindings() {
      return {
        rhythm: function rhythm(_ref) {
          var $try = _ref.$try,
              field = _ref.field,
              props = _ref.props;
          var extra = field.extra || {};
          return {
            type: $try(props.type, field.type),
            // Pass the fields name as the id, otherwise mobx-react-form appends a number to the id, which break the
            // relationship with labels etc.
            id: $try(props.id, field.name),
            name: $try(props.name, field.name),
            value: $try(props.value, field.value),
            placeholder: $try(props.placeholder, field.placeholder),
            label: $try(props.label, field.label),
            // inputFormatSuggestion: $try(props.inputFormatSuggestion, field.inputFormatSuggestion),
            labelProps: $try(props.label, extra.labelProps),
            tooltip: $try(props.tooltip, extra.tooltip),
            tooltipProps: $try(props.tooltip, extra.tooltipProps),
            helpText: $try(props.helpText, extra.helpText),
            options: $try(props.options, extra.options),
            error: $try(props.error, field.error),
            required: $try(props.required, field.computedIsRequired),
            disabled: $try(props.disabled, field.disabled),
            onChange: $try(props.onChange, field.onChange),
            onBlur: $try(props.onBlur, field.onBlur),
            onFocus: $try(props.onFocus, field.onFocus),
            autoFocus: $try(props.autoFocus, field.autoFocus)
          };
        }
      };
    }
  }, {
    key: "hasChanged",
    get: function get() {
      return this.changed || this.manuallyChanged;
    }
  }, {
    key: "hasBeenSubmitted",
    get: function get() {
      return this.hasSubmitted;
    }
  }, {
    key: "sections",
    get: function get() {
      return this.formConfig.sections;
    }
  }], [{
    key: "initialiseFromConfig",
    value: function initialiseFromConfig(configData) {
      var initialValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var formOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var customValidators = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var formHooks = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var formOptionDefaults = {
        validateOnInit: false,
        validationDebounceWait: 0,
        validateOnBlur: true,
        validateOnChange: false
      };
      var fields = [];
      var extra = {};
      var labels = {};
      var hooks = {};
      var validators = {};
      var placeholders = {};
      var bindings = {};
      var types = {};
      var defaults = {};
      var fieldConfigs = {};
      var options = Object.assign({}, formOptionDefaults, formOptions);

      var parseField = function parseField(field) {
        var idPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var fieldKey = "".concat(idPrefix).concat(field.id);
        var fieldValidators = customValidators[fieldKey] || [];
        var requiredMessage = field.requiredMessage || 'This field is required';
        fields.push(fieldKey);

        if (field.required) {
          fieldValidators.push((0, _isRequired.default)(requiredMessage));
        } // Build a list of validator functions from the config


        (field.validators || []).forEach(function (v) {
          fieldValidators.push(_ConfigParser.default.mapValidationRule(v));
        });

        if (fieldValidators.length) {
          validators[fieldKey] = fieldValidators;
        }

        if (field.placeholder) {
          placeholders[fieldKey] = field.placeholder;
        }

        types[fieldKey] = field.type || 'text';
        extra[fieldKey] = {
          required: field.required,
          requiredMessage: requiredMessage,
          tooltip: field.tooltip && /*#__PURE__*/_react.default.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: field.tooltip
            }
          }),
          options: field.options || [],
          rules: field.rules || [],
          labelProps: {
            helpText: field.helpText && /*#__PURE__*/_react.default.createElement("span", {
              dangerouslySetInnerHTML: {
                __html: field.helpText
              }
            }) // inputFormatSuggestion: field.inputFormatSuggestion

          },
          props: field.data || {}
        };

        if (field.autocomplete !== undefined) {
          extra[fieldKey].autocomplete = field.autocomplete;
        }

        if (field.inputFormatSuggestion !== undefined) {
          extra[fieldKey].inputFormatSuggestion = field.inputFormatSuggestion;
        }

        bindings[fieldKey] = field.bindings || 'rhythm';
        labels[fieldKey] = field.label;
        hooks[fieldKey] = field.hooks;
        fieldConfigs[fieldKey] = field.config;

        if (field.default !== undefined) {
          defaults[fieldKey] = field.default;
        }
      }; // Parse fields


      if (configData.fields && configData.fields.length) {
        configData.fields.forEach(function (field) {
          parseField(field);
        });
      } // Parse fields defined in sections


      if (configData.sections && configData.sections.length) {
        configData.sections.forEach(function (section) {
          section.fields.forEach(function (field) {
            parseField(field,
            /* idPrefix = */
            "".concat(section.id, "__"));
          });
        });
      } // Initial values will override defaults


      var values = _objectSpread(_objectSpread({}, defaults), initialValues);

      return new Form({
        fields: fields,
        extra: extra,
        labels: labels,
        hooks: hooks,
        placeholders: placeholders,
        validators: validators,
        bindings: bindings,
        types: types,
        values: values,
        defaults: defaults,
        options: fieldConfigs
      }, {
        options: options,
        hooks: formHooks
      }, configData);
    }
  }]);

  return Form;
}(_mobxReactForm.Form), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "manuallyChanged", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "hasSubmitted", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setManuallyChanged", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setManuallyChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasChanged", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFormSubmitted", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFormSubmitted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasBeenSubmitted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasBeenSubmitted"), _class.prototype)), _class);
var _default = Form;
exports.default = _default;
//# sourceMappingURL=Form.js.map